import { Link } from "react-router-dom";
import { useYokohamaData } from "../../../lib/useMockData";

export default function HeroSection() {
  const { heroData } = useYokohamaData();
  return (
    <section className="relative h-[520px] md:h-[720px] lg:h-[820px] overflow-hidden">
      <img
        src={heroData.image}
        alt="横浜夜景ヘリコプター遊覧"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-airdoa-navy/60 via-airdoa-navy/30 to-airdoa-navy/70" />

      <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-4">
        <p className="text-xs md:text-sm tracking-ultra text-airdoa-gold mb-4 md:mb-6 animate-fade-in">
          {heroData.label}
        </p>
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-serif font-bold text-white leading-[1.3] whitespace-pre-line animate-slide-up animation-delay-200">
          {heroData.title}
        </h1>
        <p className="mt-5 md:mt-7 max-w-2xl text-sm md:text-base text-white/80 leading-relaxed animate-slide-up animation-delay-300">
          {heroData.subtitle}
        </p>
        <div className="mt-8 md:mt-12 flex flex-col sm:flex-row items-center gap-3 md:gap-4 animate-slide-up animation-delay-400">
          <Link to={heroData.ctaPrimary.href} className="btn-primary">
            {heroData.ctaPrimary.label}
          </Link>
          <Link to={heroData.ctaSecondary.href} className="btn-ghost">
            {heroData.ctaSecondary.label}
          </Link>
        </div>
      </div>
    </section>
  );
}
